import React from 'react';
import Modal from 'react-modal';
import { useTheme } from '../../lib/ThemeContext';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';

Modal.setAppElement('#root');

interface ProfileModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

const ProfileModal = ({ isOpen, onRequestClose }: ProfileModalProps) => {
  const { isDarkMode, currentTheme } = useTheme();
  const { t } = useTranslation();
  const { user, logout } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel={t('auth.profileModalTitle', 'Profile')}
      style={{
        overlay: {
          zIndex: 9999,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        content: {
          position: 'fixed',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          transform: 'translate(-50%, -50%)',
          width: '90vw',
          maxWidth: 420,
          minWidth: 260,
          padding: 24,
          borderRadius: 12,
          background: isDarkMode ? currentTheme.paper : '#fff',
          color: isDarkMode ? currentTheme.textPrimary : '#222',
          boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
        }
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <p style={{ marginBottom: '16px', wordBreak: 'break-all' }}>{user.email || user.displayName || t('auth.loggedInAs', 'Logged in')}</p>
        <button
          onClick={async () => {
            await logout();
            onRequestClose();
          }}
          style={{
            margin: '0 8px',
            padding: '8px 24px',
            borderRadius: 4,
            background: isDarkMode ? currentTheme.buttonHoverBg : '#eee',
            color: isDarkMode ? currentTheme.textPrimary : '#222',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          {t('auth.logout', 'Log out')}
        </button>
        <button
          onClick={onRequestClose}
          style={{
            margin: '0 8px',
            padding: '8px 24px',
            borderRadius: 4,
            background: isDarkMode ? currentTheme.buttonHoverBg : '#eee',
            color: isDarkMode ? currentTheme.textPrimary : '#222',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          {t('auth.close', 'Close')}
        </button>
      </div>
    </Modal>
  );
};

export default ProfileModal; 